import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepTwoExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepTwoExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.findWordsStepTwoExtraCollections.data
      .findWordsStepTwoExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepTwoExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
